export const localStorageKeys = {
  authToken: 'authToken',
  isGDPRShowed: 'isGDPRShowed', // show GDPR again,
  allBackendSettings:'allBackendSettings',
};
  